<template>
  <v-container fluid class="fill-height pa-0">
    <v-row no-gutters class="fill-height">
      <v-col class="dark-image-bg pa-6 hidden-sm-and-down">
        <v-row align="center" class="fill-height">
          <v-flex>
            <h1 class="welcome-message text-center pb-4 font-weight-regular" v-html="$t( 'message.ssoPanelTitle' )"></h1>
          </v-flex>
        </v-row>
      </v-col>
      <v-col align="center" class="pa-6 ma-auto white">
        <div class="sign-in-up pt-12 pt-sm-0 pt-md-0 pt-lg-0 pt-xl-0">
          <v-form ref="form" v-model="formValid" lazy-validation @submit.prevent="submit">
            <h2 class="pb-1 mb-6 text-left font-weight-regular" v-html="$t( 'message.ssoSignupTitle' )"></h2>
            <div class="mb-6" v-if="email">
              <div class="user-identity-modern d-flex align-center justify-center pa-4 rounded-lg">
                <v-avatar color="primary" size="42" class="mr-4 elevation-1">
                  <span class="white--text font-weight-bold text-subtitle-1">
                    {{ avatarInitials }}
                  </span>
                </v-avatar>
                <div class="d-flex flex-column text-left overflow-hidden" style="max-width: 70%;">
                  <span class="text-subtitle-2 font-weight-bold grey--text text--darken-4 text-truncate">
                    {{ name }}
                  </span>
                  <span class="caption grey--text text--darken-1 text-truncate">
                    {{ email }}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <v-text-field
                  v-model="company"
                  name="company"
                  :disabled="loading"
                  :label="$t( 'message.Organization' )"
                  persistent-hint
                  :rules="[validateFullName]"
                  @keydown.enter="submit"
              ></v-text-field>
            </div>
          </v-form>
          <div class="text-center terms-disclaimer py-4" v-html="$t( 'message.AcceptTermsOfUseAndPrivacyPolicy' )">
          </div>
          <p class="mt-7" v-bind:class="{ 'cvw-status-message': error }">{{ error }}</p>
          <div class="text-center mt-8">
            <v-btn
                @click="submit"
                :disabled="!formValid || !company || loading"
                class="primary-btn mt-3"
            >
              {{ $t( 'message.SignUpButtonLabel' ) }}
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <sh-app-footer class="pb-0"></sh-app-footer>
  </v-container>
</template>

<script>
    import AppFooter from "../../components/common/AppFooter";
    import {globalEvents, JSONPureClient} from "@cloudlace/client";
    import ssoSignupServiceMap from "../../api/sso-signup-service-map";
    import util from "../../util/util";

    const ssoSignupClient = new JSONPureClient( {
        service_url : process.env.VUE_APP_SHIO_CORE_SSO_SIGNUP_URL,
        service_map : ssoSignupServiceMap
    } );
    export default {
        name : "SsoRegistrationPane",
        data()
        {
            return {
                loading : false,
                formValid : false,
                error : null,
                setup_token : null,
                email : null,
                username : null,
                name : null,
                company : "",
                externalIdentity : null,
                redirect_url : null
            };
        },
        computed : {
            avatarInitials()
            {
                if( !this.name )
                {
                    return "?";
                }
                const parts = this.name.trim().split( " " );
                if( parts.length >= 2 )
                {
                    return (parts[ 0 ][ 0 ] + parts[ parts.length - 1 ][ 0 ]).toUpperCase();
                }
                return this.name.substring( 0, 1 ).toUpperCase();
            }
        },
        created()
        {
            this.setup_token = this.$route.query.token;
            this.redirect_url = this.$route.query.return_url;
            if( !this.setup_token )
            {
                this.error = this.$t( "message.Error!Unexpected" );
            }
            this.fetchSsoContext( this.setup_token );
        },
        components : {
            "sh-app-footer" : AppFooter,
        },
        methods : {
            /**
             * Full name validator.
             */
            validateFullName : util.validateFullName,
            fetchSsoContext( token )
            {
                this.loading = true;
                ssoSignupClient.retrieveSsoContext( token ).then( result =>
                {
                    this.name = result.name;
                    this.username = result.username;
                    this.email = result.email;
                    this.loading = false;
                } ).catch( () =>
                {
                    this.loading = false;
                    this.error = this.$t( "message.Error!Unexpected" );
                } )
            },
            submit()
            {
                if ( this.loading ) {
                    return;
                }
                if( !this.$refs.form.validate() )
                {
                    return;
                }
                this.error = null;
                this.loading = true;
                const locale = this.$i18n.locale || 'en';
                ssoSignupClient.createSsoUser( this.setup_token, this.company, "shio.*", locale ).then( result =>
                {
                    this._handleSessionResult( result );
                } ).catch( () =>
                {
                    this.loading = false;
                    this.error = this.$t( "message.Error!Unexpected" );
                } )
            },
            _handleSessionResult( result )
            {
                if( result.scope.length === 0 )
                {
                    globalEvents.emit( "signed-out", {} );
                }
                else if( this.redirect_url )
                {
                    window.location.assign( this.redirect_url );
                }
                else
                {
                    window.$cc_user_info = result;
                    globalEvents.emit( "signed-in", result );
                }
            }
        }
    };
</script>

<style lang="sass" scoped>
  .relative
    position: relative

  .lh-relaxed
    line-height: 1.6

  .user-identity-modern
    background-color: #ffffff
    border: 1px solid #e0e6ed
    transition: all 0.2s ease-in-out

  .user-identity-modern:hover
    border-color: #b0b8c4
    background-color: #fafbfc
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05)

  .welcome-subtitle
    font-size: 24px
</style>